import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

export interface NotifyPeopleModalFooterProps {
  customPrimaryButtonLabel?: string;
  customSecondaryButtonLabel?: string;
  isActionDisabled?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const NotifyPeopleModalFooter = ({
  customPrimaryButtonLabel,
  customSecondaryButtonLabel,
  isActionDisabled = false,
  onCancel,
  onConfirm,
}: NotifyPeopleModalFooterProps) => (
  <Box>
    <Button variant="secondary" onClick={onCancel}>
      {customSecondaryButtonLabel ?? __('Cancel')}
    </Button>
    <Button ml={2} onClick={onConfirm} isDisabled={isActionDisabled}>
      {customPrimaryButtonLabel ?? __('Confirm selection')}
    </Button>
  </Box>
);
